<mat-divider [vertical]="vertical"></mat-divider>
<p><ng-content></ng-content></p>
<mat-divider [vertical]="vertical"></mat-divider>
